import { Component, Inject } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MarkdownModule } from 'ngx-markdown';

import Resources from '@constants/resourses';
import Utils from '@constants/utils';
import { AlertDialogData } from './alert-dialog.interface';

import { SessionService } from '@services/session.service';
import { TealiumUtagService } from '@services/utag.service';

@Component({
  selector: 'app-alert-dialog',
  standalone: true,
  imports: [MatDialogModule, MarkdownModule],
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss']
})
export class AlertDialogComponent {
  pageId: string;
  tealiumData: any;
  alert: AlertDialogData;
  ids: string;

  constructor(
    public dialogRef: MatDialogRef<any>,
    private sessionService: SessionService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private tealium: TealiumUtagService
  ) {
    this.tealiumData = this.sessionService.getItemFromSession(Resources.SessionStorageKeys.TealiumData) || {};
    this.alert = {
      pageName: data.pageName,
      title: data.title,
      message: data.message,
      buttonText: data.buttonText
    };
  }

  ngOnInit(): void {
    this.tealiumData['page_name'] = this.alert?.pageName || 'AlertDialog';
    this.tealiumData['page_type'] = 'PaymentPage';
    this.tealiumData['base_url'] = window.location.href;
    this.tealiumData['tealium_event'] = 'view';


    this.ids = this.tealiumData['app_name'] + '_' + this.tealiumData['page_name'] + '_' + Utils.toUpperCamelCase(this.alert?.buttonText, ' '),

    // Trigger tealium view event
    this.tealium.viewEvent(this.tealiumData);
  }

  // Close the dialog
  target(): void {
    this.tealiumData['event_category'] = '';
    this.tealiumData['event_label'] = Utils.toUpperCamelCase(this.alert?.buttonText, ' ');

    // Trigger tealium link event
    this.tealium.linkEvent(this.tealiumData);

    this.dialogRef.close();
  }
}
